import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_event_info';
export const useTopMatchEventInfoTranslation = (): UseTranslationResponse<string, string> => (
  useTranslation('entities', { keyPrefix })
);

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    similarity: 'Событие',
    create_time: 'Дата создания',
    source: 'Источник',
    handler: 'Сценарий',
    location: 'Место',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    similarity: 'Event',
    create_time: 'Created',
    source: 'Source',
    handler: 'Handler',
    location: 'Location',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    similarity: 'Evento',
    create_time: 'Criado em',
    source: 'Fonte',
    handler: 'Cenário',
    location: 'Local',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    similarity: 'Evento',
    create_time: 'Creado',
    source: 'Fuente',
    handler: 'Escenario',
    location: 'Ubicación',
  },
}) : {}) as Record<string, unknown>;
